import { render, staticRenderFns } from "./CardWithImageAndButton.vue?vue&type=template&id=7a01154c&"
import script from "./CardWithImageAndButton.vue?vue&type=script&lang=js&"
export * from "./CardWithImageAndButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/usr/src/app/components/base/Btn.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardTitle,VLazy})
